export const formatDate = (dateString) => {
	if (!dateString) return null;
	const date = new Date(dateString);
	return `${date.toLocaleTimeString("it-IT", {
		timeZone: "Europe/Rome",
		hour: "2-digit",
		minute: "2-digit",
	})} del ${date.toLocaleDateString("it-IT", {
		timeZone: "Europe/Rome",
		day: "numeric",
		month: "long",
		year: "numeric",
	})}`;
};

export function parseCustomDate(dateString) {
	// Definizione delle corrispondenze per i mesi e i giorni della settimana
	const months = {
		gen: "Jan",
		feb: "Feb",
		mar: "Mar",
		apr: "Apr",
		mag: "May",
		giu: "Jun",
		lug: "Jul",
		ago: "Aug",
		set: "Sep",
		ott: "Oct",
		nov: "Nov",
		dic: "Dec",
	};

	// Rimuove "di" e converte la stringa
	const cleanString = dateString.replace("di", "").trim();
	const regex = /(\d{1,2}):(\d{2})\s+(\w+)\s+(\d{1,2})\s+(\w+)\s+(\d{4})/;
	const match = cleanString.match(regex);

	if (!match) {
		throw new Error("Formato data non valido");
	}

	// Estrai le parti della data
	const [, hours, minutes, , day, monthAbbrev, year] = match;

	// Converte il mese in inglese
	const month = months[monthAbbrev.toLowerCase()];

	if (!month) {
		throw new Error("Mese non valido");
	}

	// Combina in un formato leggibile da `Date`
	const standardDateString = `${year} ${month} ${day} ${hours}:${minutes}:00`;
	return new Date(standardDateString);
}
